<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle :title="config.PROFILE_EDIT_TITLE"/>
            <section class="infos">
                <p>{{ config.PREFERENCES_SUBTITLE }}</p>
                <Preferences v-model="preferences"/>
            </section>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" :disabled="loading" flat @click="onCancel">
                    {{ config.PROFILE_EDIT_CANCEL }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" :disabled="loading" @click="onSubmit">
                    {{ config.PROFILE_EDIT_SAVE }}
                </Button>
            </SectionActions>
        </main>
    </page>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { SectionTitle, SectionActions, Preferences } from '../../components/shared';

export default {
    name: 'ProfileEditPreferences',
    components: {
        Preferences, Page, SectionTitle, SectionActions,
    },
    mixins: [SolutionConsumer, UserConsumer],
    data () {
        return {
            loading: false,
            preferences: [],
        };
    },
    created () {
        this.preferences = this.user.preferences;
    },
    methods: {
        onCancel () {
            this.$router.go(-1);
        },
        async onSubmit () {
            try {
                this.loading = true;

                // Update user info
                await this.editUser({
                    preferences: this.preferences,
                });
                // Update local copy
                await this.updateUser();
                this.$router.push({ name: 'profile' });
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(20px);

    > section {
        &.infos {
            > p {
                margin-bottom: 20px;
            }
        }
    }
}
</style>
